<template>
    <div>
        <div class="options d-flex align-items-center m-3 justify-content-between">
            <div class="d-flex align-items-center col-sm-6 pl-0">
                <div class="d-flex w-100">
                    <input class="glued-right bg-lighter w-100" type="text" v-model="searchQuery" placeholder="Search">
                    <div class="glued-left dark"><i class="ico-search larger color-1"></i></div>
                </div>

				<div class="d-flex m-3 align-items-center w-100 ml-3">
					<span class="fs-small bold mr-2">Show inactive products</span>
					<toggle-button @change="toggleShowInactive" v-model="showInactive" :labels="{checked: 'Yes', unchecked: 'No'}" />
				</div>
            </div>

            <button class="btn" @click="addProduct">
                <i class="ico ico-add mt-1"></i> Add Product
            </button>
        </div>

        <div v-if="getLoadingProducts" class="p-4 text-center">
            <loader></loader>
        </div>

        <div v-else>
            <list :header="header" :body="body" :rows="filteredResults" :actions="actions"></list>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    import List from '@/tools/list/baseList'
    import Search from '@/tools/Search'
    import Export from '@/tools/Export'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data() {
            return {
                searchQuery: null,
                loading: false,
                body: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        name: this.formatName,
                        category: this.formatCategory,
                        active: this.formatActive
                    },
                    customRowEvent: this.view,
                },
                actions: {
                    label : 'Actions',
                    list: [
                        {
                            slug: 'duplicate',
                            title: 'Duplicate',
                            tooltip: 'Duplicate',
                            params: '',
                            class: '',
                            icon: 'fas fa-clone largest',
                            event: this.duplicateProduct,
                        },
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.view,
                        },
                        {
                            slug: 'delete',
                            title: 'Delete',
                            tooltip: 'Delete',
                            params: '',
                            class: '',
                            icon: 'ico-delete largest',
                            event: this.remove,
                        }
                    ],
                },
				showInactive: false,
            }
        },
		created() {
			this.showInactive = localStorage.getItem('showInactiveProducts') === 'true';
		},
		props: {
			showInactiveProducts: {
				type: Boolean,
				default: false
			}
		},
        computed: {
            ...mapGetters([
                'getProducts',
                'getProductsLabels',
                'account',
                'getLoadingProducts',
                'getShowInvoiceOption'
            ]),
            header() {
                const resourcesLabel =this.getProductsLabels;
                const labels = {};

                labels.name = resourcesLabel.name;

                if (this.getShowInvoiceOption) {
                    labels.code = resourcesLabel.code;
                }

                labels.category = resourcesLabel.category;

                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: labels,
                };
            },
            filteredResults() {
                // Just to sort alfabetically
                function compare(a,b) {
                    if (a.name.toLowerCase() < b.name.toLowerCase())
                        return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase())
                        return 1;
                    return 0;
                }

                let output = null;
                
                if (this.searchQuery) {
                    output = this.getProducts.filter(product => {
                        return product.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                    });
                } else {
                    output = this.getProducts;
                }

                return output.sort(compare);
            }
        },
        methods: {
            ...mapActions([
                'setSelectedItem',
                'addItem',
                'removeItem',
                'flushEvents',
                'openModal',
                'requestProductSchedulesRestrictions'
            ]),
			toggleShowInactive() {
				this.$emit('showInactiveProducts', this.showInactive);
			},
            duplicateProduct(item) {
                if (item.id !== undefined) {
                    this.setSelectedItem({ table: 'products', id: item.id });
                    this.openModal('ProductDuplicate');
                }
            },
            view(item) {
                const productId = item.id;

                if (productId !== undefined) {
                    this.setSelectedItem({ table: 'products', id: productId });
                    this.$router.push({ name: 'pluralo.product.edit', params: { id: productId } });
                }
            },
            addProduct() {
                this.$router.push({ name: 'pluralo.product.new' });
            },
            remove(item) {
                let vm = this;

                this.removeItem({
                    table: 'products',
                    object: 'product',
                    module: 'inventory',
                    fields: { supplierId: this.account.supplierId, Product: item }
                }).then(function() {
                    vm.flushEvents();
                });
            },
            formatName(item) {
                return '<div class="bold">' + item.name + '</div>';
            },
            formatIsActive(item) {
                return item.isActive ? 'Active' : '<div class="color-6">Inactive</div>';
            },
            formatCategory(item) {
                return (item.categoryList.length > 0) ? item.categoryList.map(i => i.name).join(', ') : '-';
            },
            formatDuration(item) {
                return (item.duration !== undefined) ? item.duration : '-';
            },
            formatDurationRange(item) {
                if (!item.groups[0]) {
                    return ' - '
                }
                let higherHour = item.groups[0].schedules[0].duration;
                let lowerHour = item.groups[0].schedules[0].duration;

                item.groups.map(group => {
                    group.schedules.map(schedule => {
                        higherHour = (schedule.duration > higherHour)? schedule.duration : higherHour
                        lowerHour = (schedule.duration < lowerHour)? schedule.duration : lowerHour
                    })
                });


                if (higherHour == lowerHour ){
                    return moment.duration(higherHour).format("h:mm");
                } else {
                    return moment.duration(lowerHour).format("h:mm") + ' to ' + moment.duration(higherHour).format("h:mm");
                }
            },
            formatActive(item) {
                return (item.active) ? 'Yes' : 'No';
            },
            cancel(item) {
                alert('Delete ' + item.name);
            }
        },
        components: {
            List,
            Search,
            Export,
            Loader
        },
    }
</script>



// WEBPACK FOOTER //
// Products.vue?6ac5d9b9